module.exports = __webpack_public_path__ + "6b3d6c06f3ca12681e8823192ee5c200.glb";